import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import NotFound from 'modules/core/components/NotFound'
import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import type GoalConfig from 'modules/goals/store/models/GoalConfig'

import Header from './_Header'
import GoalTable from './_Table'

interface InfoProps {
  title: string
  content: string
  style?: Partial<CSSStyleDeclaration>
}

const Info = ({ title, content, style }: InfoProps) => {
  return (
    <Box style={style}>
      <Text size="200" color="grey800">
        {title}
      </Text>
      <Box paddingTop="s8">
        <Text size="200" whiteSpace="breakSpaces">
          {content}
        </Text>
      </Box>
    </Box>
  )
}

interface ContentProps {
  goalConfig: GoalConfig
  showActions?: boolean
  canSeeClockedIn: boolean
  contractVersions: ContractVersions
}

const Content = ({ goalConfig, showActions, canSeeClockedIn, contractVersions }: ContentProps) => {
  const displayDate = (date: string) => (date ? dateBackendDateTimeToUI(date) : '-')

  if (!goalConfig) {
    return <NotFound />
  }

  return (
    <Box gap="s24">
      <Box
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'grey400',
          },
        }}
        borderRadius={{
          all: 'abs008',
        }}
      >
        <Header showActions={showActions} goalConfig={goalConfig} />
        <Box flexDirection="row" gap="s48" paddingX="s32" paddingY="s24">
          <Info
            style={{
              flex: '1',
            }}
            title={i18n.t('surveys.goals.common.description')}
            content={goalConfig.attributes.description}
          />
          <Box
            flexDirection="row"
            gap="s48"
            style={{
              flex: '1',
            }}
          >
            <Info
              title={i18n.t('surveys.goals.common.start_date')}
              content={displayDate(goalConfig.attributes.start_date)}
            />
            <Info
              title={i18n.t('surveys.goals.common.due_date')}
              content={displayDate(goalConfig.attributes.due_date)}
            />
          </Box>
        </Box>
      </Box>
      <GoalTable
        showActions={showActions}
        goalConfig={goalConfig}
        canSeeClockedIn={canSeeClockedIn}
        contractVersions={contractVersions}
      />
    </Box>
  )
}

export default observer(Content)
